import { ReactNode } from 'react';

import cx from 'classnames';

import i18n from 'i18n/config';

import styles from './styles.module.scss';

const INFO_LIST = i18n.t('auth:disable2FA.requiredInfo', {
  returnObjects: true,
}) as string[];

const textDescription = i18n.t('auth:disable2FA.description');

const RaiseDisable2FATicketInfo = ({
  btnSection,
  className,
  heading,
  description,
}: {
  btnSection: ReactNode;
  className?: string;
  heading?: ReactNode;
  description?: string | null;
}) => {
  return (
    (<div
      className={cx(styles.wrapper, className)}
      data-palette="RaiseDisable2FATicketInfo">
      {heading}
      <div className={styles.parent}>
        <div className={styles.textSection}>
          <div className={styles.description}>{description ?? textDescription}</div>
          <div className={styles.list}>
            {INFO_LIST.map?.(item => (
              <li key={item} data-palette="RaiseDisable2FATicketInfo">{item}</li>
            ))}
          </div>
        </div>
        {btnSection}
      </div>
    </div>)
  );
};

export { RaiseDisable2FATicketInfo };
